import { TimeOutActionType } from "../Constants/TimeOutActionType";

export const setTimeOut = timeOut => {
	return {
		type: TimeOutActionType.SET_TIMEOUT,
		payload: timeOut,
	};
};
